import { render, staticRenderFns } from "./RegisterModal.vue?vue&type=template&id=170eeef3&scoped=true"
import script from "./RegisterModal.vue?vue&type=script&lang=ts"
export * from "./RegisterModal.vue?vue&type=script&lang=ts"
import style0 from "./RegisterModal.vue?vue&type=style&index=0&id=170eeef3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170eeef3",
  null
  
)

export default component.exports